const enterpriseIds = {
    atci_lkm_lis_portaldevelopment: "ATCI.LKM.LIS.PORTALDEVELOPMENT",
    securityind_learning: "SecurityIND.Learning"
};

const domain = "accenture.com";

const atcilkmlisportaldevelopment = `${enterpriseIds.atci_lkm_lis_portaldevelopment}@${domain}`;
const securityindlearning = `${enterpriseIds.securityind_learning}@${domain}`;

export default { atcilkmlisportaldevelopment,securityindlearning };